import EducationCard from './educationCard'
export default EducationCard
